var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0199 13.1156H14.9803C11.3643 13.1156 8.42252 10.1738 8.42252 6.55782C8.42252 2.94186 11.3643 0 14.9803 0H15.0198C18.6359 0 21.5776 2.94186 21.5776 6.55782C21.5776 10.1738 18.6359 13.1156 15.0199 13.1156V13.1156ZM14.9803 1.92308C12.4246 1.92308 10.3455 4.00224 10.3455 6.55782C10.3455 9.1134 12.4247 11.1926 14.9803 11.1926H15.0198C17.5755 11.1926 19.6546 9.1134 19.6546 6.55782C19.6546 4.00224 17.5755 1.92308 15.0199 1.92308H14.9803Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0384 30H17.7956V28.077H23.9743V17.1759L20.7444 16.0036L15.7289 21.8343C15.3524 22.2722 14.6476 22.2722 14.271 21.8343L9.25555 16.0036L6.02562 17.1759V28.077H12.1795V30H5.96151C4.93645 30 4.10254 29.1661 4.10254 28.1411V17.131C4.10254 16.3517 4.59472 15.6495 5.32728 15.3836L9.2235 13.9694C9.59901 13.833 10.0199 13.9432 10.2806 14.2462L15 19.7329L19.7195 14.2462C19.98 13.9432 20.4009 13.833 20.7764 13.9694L24.6727 15.3836C25.4052 15.6494 25.8974 16.3516 25.8974 17.131V28.1411C25.8974 29.1661 25.0635 30 24.0384 30Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9875 28.077H16.2148V30H13.9875V28.077Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.412d7729a4d73c41c019a3d9730acdd0.svg";
export { ForwardRef as ReactComponent };